import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65c2324c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=65c2324c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2324c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c2324c')) {
      api.createRecord('65c2324c', component.options)
    } else {
      api.reload('65c2324c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=65c2324c&scoped=true&", function () {
      api.rerender('65c2324c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/warehouse-goods/modules/table-list/index.vue"
export default component.exports